import { Component } from '@angular/core';

@Component({
  selector: 'uni-box-actions',
  templateUrl: './uni-box-actions.component.html',
  styleUrls: ['./uni-box-actions.component.scss'],
})
export class UniBoxActionsComponent {}
